import { render } from "./App.vue?vue&type=template&id=3a67f3e6&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3a67f3e6&scoped=true&lang=css"

import exportComponent from "E:\\火灵\\webStorm\\pay-admin-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a67f3e6"]])

export default __exports__